<template>
  <div class="page-table person-list">
    <div class="page-search">
      <a-form :form="searchForm" @submit="handleSearch">
        <a-row>
          <a-col :span="6">
            <a-form-item label="姓名" :labelCol="{span: 4}" :wrapperCol="{span: 18}">
              <a-input v-decorator="['xm']" placeholder="请输入用户名" maxlength="10" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="类型" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
              <a-select allowClear :options="lxDict" v-decorator="['yhlx']" placeholder="全部类型"></a-select>
            </a-form-item>
          </a-col>
          <a-col :span="2" style="line-height: 39px;">
            <a-button style="margin-left: 20px;" type="primary" html-type="submit">查询</a-button>
          </a-col>
          <a-col :span="10" style="text-align:right;line-height: 39px;">
            <a-button style="margin-right:20px;" @click="showModal" type="primary">新增人员</a-button>
            <a-button @click="exportExe" type="primary">导出</a-button>
          </a-col>
        </a-row>
      </a-form>
      <!-- 表格 -->
      <div class="table-operator" style="margin-top: 15px;padding: 0;">
        <standard-table
          :columns="columns"
          :dataSource="dataSource"
          @change="onChange"
          @rowChange="onRowChange"
        />
      </div>
    </div>
    <!-- 弹框 -->
    <a-modal
      destroyOnClose
      :maskClosable="false"
      :title="`${ current.id ? '编辑' : '新建' }用户`"
      v-model="visible"
      width="670px"
      @ok="handleSubmit"
    >
      <a-form :form="form">
        <a-form-item label="类型" :labelCol="{span: 5}" :wrapperCol="{span: 18}">
          <a-radio-group
            :disabled="current.id ? true : false "
            @change="onChangeyhlx"
            v-decorator="['yhlx', {rules: [{ required: true, message: '请选择类型！'}]}]"
            name="lxradioGroup"
          >
            <a-radio v-for="list in lxDict" :key="list.value" :value="list.value">{{ list.label }}</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="登录名" :labelCol="{span: 5}" :wrapperCol="{span: 18}">
          <a-input
            :disabled="current.id ? true : false "
            v-decorator="[
              'ddm',
              {
                rules:[
                  { required: true,message: '请输入用户名！'},
                  { pattern: /^[0-9a-zA-Z]{2,10}$/, message: '2-10位字母或数字组成！' }
                ]
              }
            ]"
            placeholder="请输入用户名"
            maxlength="10"
          />
        </a-form-item>
        <!-- { pattern: /^[\s\S]{6,20}$/, message: '密码长度6～20位' }  -->
        <a-form-item label="姓名" :labelCol="{span: 5}" :wrapperCol="{span: 18}">
          <a-input
            v-decorator="[
              'xm',
              {
                rules: [
                  { required: true, message: '请输入姓名！' }
                ]
              }
            ]"
            placeholder="请输入姓名"
            maxlength="20"
          />
        </a-form-item>
        <a-form-item label="性别" :labelCol="{span: 5}" :wrapperCol="{span: 18}">
          <a-radio-group
            v-decorator="['xb', {rules: [{ required: true, message: '请选择性别！'}]}]"
            name="radioGroup"
          >
            <a-radio value="1">男</a-radio>
            <a-radio value="2">女</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="手机号码" :labelCol="{span: 5}" :wrapperCol="{span: 18}">
          <a-input
            v-decorator="[
              'sjhm',
              {
                rules:[
                  { required: true,message: '请输入手机号码！'},
                  {  pattern: /^1\d{10}$/, message: '请输入正确的格式！'}
                ]
              }
            ]"
            placeholder="请输入手机号码"
            maxlength="11"
          />
        </a-form-item>
        <a-form-item label="身份证号码" :labelCol="{span: 5}" :wrapperCol="{span: 18}">
          <a-input
            v-decorator="[
              'sfz',
              {
                rules:[
                  { required: true,message: '请输入身份证号码！'},
                  {  pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '请输入正确的格式！'}
                ]
              }
            ]"
            placeholder="请输入身份证号码"
            maxlength="18"
          />
        </a-form-item>
        <!-- <a-form-item label="所属校区" :labelCol="{span: 5}" :wrapperCol="{span: 18}">
          <a-radio-group
            v-decorator="['ssxq', {rules: [{ required: true, message: '请选择校区！'}]}]"
            name="radioGroup"
          >
            <a-radio value="01">文津校区</a-radio>
            <a-radio value="02">新芜校区</a-radio>
          </a-radio-group>
        </a-form-item> -->
        <a-form-item v-if="!isnotWxy" label="管理区域" :labelCol="{span: 5}" :wrapperCol="{span: 18}">
          <a-tree-select
            v-decorator="['glqy',
            {rules: [{ required: true, message: '请选择管理区域！'}]}
            ]"
            :treeData="treeData"
            treeCheckable
            :showCheckedStrategy="SHOW_PARENT"
          />
        </a-form-item>
        <a-form-item v-if="!isnotWxy" label="擅长工种" :labelCol="{span: 5}" :wrapperCol="{span: 19}">
          <a-checkbox-group
            style="line-height:40px;width:100%"
            v-decorator="['gz', {rules: [{ required: true, message: '请勾选擅长工种！'}]}]"
          >
            <a-col :span="6" v-for="(ckeckList, index) in ckeckList" :key="index">
              <a-checkbox :value="ckeckList.id">{{ckeckList.mc}}</a-checkbox>
            </a-col>
          </a-checkbox-group>
        </a-form-item>
        <p style="color:red">提示：初始密码默认为Aiit#身份证后六位</p>
        <!-- <p style="color:red">提示：初始密码默认为身份证后6位</p> -->
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { TreeSelect } from 'ant-design-vue'
const SHOW_PARENT = TreeSelect.SHOW_PARENT
const env = process.env.NODE_ENV
export default {
  name: 'QueryList',
  data () {
    const columns = [
      {
        title: '序号',
        align: 'center',
        dataIndex: '_index'
      },
      {
        title: '姓名',
        align: 'center',
        dataIndex: 'xm'
      },
      {
        title: '性别',
        align: 'center',
        dataIndex: 'xbmc'
      },
      {
        title: '所属校区',
        align: 'center',
        dataIndex: 'xqmc'
      },
      // {
      //   title: '工种属性',
      //   align: 'center',
      //   customRender: (text, record, index) => {
      //     let gzList = record.list
      //     let gzStr = ''
      //     for (var i = 0; i < gzList.length; i++) {
      //       if (i !== gzList.length - 1) {
      //         gzStr += gzList[i].gzmc + ','
      //       } else {
      //         gzStr += gzList[i].gzmc
      //       }
      //     }
      //     return gzStr
      //   }
      // },
      {
        title: '类型',
        align: 'center',
        dataIndex: 'yhlxmc'
      },
      {
        title: '手机号码',
        align: 'center',
        dataIndex: 'sjhm'
      },
      {
        title: '操作',
        align: 'center',
        width: 150,
        customRender: (text, record, index) => {
          return (
            <div class="row-operator">
              <a
                href="javascript:;"
                onClick={() => this.showModal(true, record)}
              >
                编辑
              </a>
              <a-divider type="vertical" />
              <a href="javascript:;" onClick={() => this.handleRemove(record)}>
                删除
              </a>
            </div>
          )
        }
      }
    ]
    return {
      searchForm: this.$form.createForm(this),
      form: this.$form.createForm(this),
      columns,
      dataSource: [],
      selectedRows: [],
      visible: false,
      current: {},
      treeData: [],
      SHOW_PARENT,
      ckeckList: [],
      scgzCheck: [],
      xm: '',
      lxDict: [],
      isnotWxy: false
    }
  },
  mounted () {
    this.fetchList(this.getFetchParams())
    this.getDropList()
  },
  methods: {
    getDropList () {
      this.$axios.post('/api/xtgl/getRylx.do').then(res => {
        this.lxDict = res.data.list
      })
    },
    // 获取列表
    fetchList (params) {
      params.currentPageNo = params.pageNum
      this.$axios.post('/api/xtgl/getWxyList.do', params).then(res => {
        this.dataSource = res.data.wxyData || []
        this.ckeckList = res.data.gzData || []
        this.treeData = res.data.glqyData
        // 处理分页情况
        const { pageNum, pageSize } = params
        this.pagination = {
          total: res.data.total || 0,
          pageNum,
          pageSize
        }
      })
    },
    // 搜索
    handleSearch (e) {
      e.preventDefault()
      this.fetchList(this.getFetchParams({ pageNum: 1 }))
    },
    onRowChange (selectedRows) {
      // console.log(selectedRows)
      this.selectedRows = selectedRows
    },
    // 切换数据
    onChange (changeParams) {
      this.fetchList(this.getFetchParams(changeParams))
    },

    /**
     * 获取请求列表参数
     * @param { Object } customParam 自定义处理
     * @return { Object } 请求列表参数
     */
    getFetchParams (customParam) {
      const { pageNum, isRemove } = customParam || {}
      let params = {
        ...this.searchForm.getFieldsValue(),
        ...this.PAGINATION,
        ...customParam
      }
      if (pageNum && params.pageNum) {
        params.pageNum = pageNum
      } else {
        params.pageNum = 1
        params.pageSize = 10
      }
      if (isRemove && params.pageNum && this.dataSource.length % 10 === 1) {
        params.pageNum = params.pageNum > 2 ? params.pageNum - 1 : 1
      }
      // 用户类型
      params.type = '0'
      return params
    },
    // 显示弹框
    showModal (visible, record) {
      this.isnotWxy = false
      this.visible = !!visible
      this.current = record || {}
      this.scgzCheck = []
      // 编辑
      if (record) {
        this.$nextTick(() => {
          if (record.yhlx !== '1') {
            this.isnotWxy = true
          } else {
            this.isnotWxy = false
          }
          setTimeout(() => {
            let fields = this.form.getFieldsValue()
            for (var key in fields) {
              fields[key] = record[key]
            }
            if (this.isnotWxy === false) {
              fields.glqy = record.glqy.split(',')
              fields.gz = []
              for (var i = 0; i < record.list.length; i++) {
                fields.gz.push(record.list[i].gz)
              }
            }
            this.form.setFieldsValue(fields)
          }, 300)
        })
      } else {
        this.$nextTick(() => {
          setTimeout(() => {
            let fields = this.form.getFieldsValue()
            fields.yhlx = '1'
            // fields.xb = '1'
            // fields.ssxq = '01'
            this.form.setFieldsValue(fields)
          }, 300)
        })
      }
    },
    // 导出
    exportExe (e) {
      e.preventDefault()
      let url = env === 'production' ? '/export/exportWxy.do' : '/api/export/exportWxy.do'
      this.epxportway(url, this.getParams())
    },
    // 导出方法
    epxportway (url, data) {
      if (url && data) {
        var form = window.$('<form></form>')
        form.attr('action', url)
        form.attr('method', 'post')
        for (var item in data) {
          var input = window.$('<input type="text" />')
          input.attr('name', item)
          input.attr('value', data[item])
          form.append(input)
        }
        form
          .appendTo('body')
          .submit()
          .remove()
      }
    },
    // 是否启用请求
    enableAjax (params) {
      this.$axios.post('/api/user/updateUserStatus', params).then(res => {
        this.$message.success(
          `成功${params.status === 1 ? ' 停用' : '启用'}！`
        )
        // 重新获取列表数据
        this.fetchList(this.getFetchParams())
      })
    },
    // 用户类型change
    onChangeyhlx (e) {
      let value = e.target.value
      if (value === '1') {
        this.isnotWxy = false
      } else {
        this.isnotWxy = true
      }
    },
    // 新增、编辑
    handleSubmit () {
      var $this = this
      this.form.validateFields((err, values) => {
        if (!err) {
          // 处理编辑时添加ID字段
          if (JSON.stringify($this.current) !== '{}') {
            values.id = $this.current.id
          }
          if (values.glqy) {
            values.glqy = values.glqy.join(',')
          }
          if (values.gz) {
            values.gz = values.gz.join(',')
          }
          // values.gz = $this.scgzCheck.join(',')
          values.ssxq = '02'
          // 接口请求
          this.submitAjax(values)
        }
      })
    },
    // 新增、编辑请求
    submitAjax (params) {
      this.$axios.post('/api/xtgl/saveOrUpdateGwxx.do', params).then(res => {
        this.$message.success(`${params.id ? ' 编辑' : '新增'}成功！`)
        this.visible = false

        this.fetchList(this.getFetchParams({ pageNum: 1 }))
      })
    },
    // 删除
    handleRemove (record) {
      this.$confirm({
        title: '提示',
        content: '确定删除该条数据？',
        okType: 'danger',
        onOk: () => {
          // 删除请求
          this.removeAjax({ id: record.id })
        }
      })
    },
    // 删除请求
    removeAjax (params) {
      this.$axios.post('/api/xtgl/deleteGwxxById.do', params).then(res => {
        this.$message.success(`删除成功！`)
        this.fetchList(this.getFetchParams({ isRemove: true }))
      })
    },
    getParams (custParam) {
      let params = {
        ...this.searchForm.getFieldsValue(),
        ...custParam
      }
      return params
    }
  }
}
</script>
<style lang="less">
.person-list {
  .ant-radio-group-outline,
  .ant-form-item-control-wrapper {
    line-height: 40px;
  }
}
.ant-layout-content .person-list .page-search {
  border-bottom: none;
}
</style>
